import { gql } from '@apollo/client';

export const GET_PRODUCT_IMAGES = gql`
  query GetProductImages($input: ProductImageLookupFilter) {
    getProductImages(input: $input) {
      partNumber
      imageName
      imageAbsoluteUrl
    }
  }
`;
